<template>
  <div class="bg-cl-white body-box">
    <div class="w-100pct h-60px bg-cl-light cl-black f-s-22px f-w-bold pd-18px t-al-center">
      <span>
        พิมพ์ใบเสร็จ
      </span>
    </div>
    <div class="columns is-marginless is-paddingless is-centered bd-rd-4px">
      <div class="column is-4">
        <div class="printer mg-10px pd-6px f-w-bold t-al-center cs-pointer" :style="`background-color: ${mainColor};`" v-for="(printer, index) in printers" :key="index" @click="finishPrint(printer.ip)">
          {{ printer.name }} <br> {{ printer.ip }}
        </div>
        <div class="no-print mg-10px pd-18px f-w-bold cs-pointer"  @click="finishPrint('no print')">
          ไม่พิมพ์ใบเสร็จ
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'receipt',
  methods: {
    ...mapActions([
      'clearAllData',
      'setIsloading',
      'printReceiptAction'
    ]),
    async finishPrint (printerIP) {
      const params = {
        printerIP,
        status: 'pending'
      }
      this.setIsloading(true)
      await this.printReceiptAction(params)
      this.clearData()
      this.setIsloading(false)
    },
    async clearData () {
      this.clearAllData()
      this.$router.push({ name: 'Home' })
    }
  },
  computed: {
    ...mapGetters({
      printers: 'getPrinters',
      billID: 'getBillID',
      mainColor: 'mainColor'
    })
  }
}
</script>

<style scoped>
.printer {
  height: 60px;
  border-radius: 4px;
  background-color: #1b0000;
  border: solid 1px #1b0000;
  color: #ffffff;
}
.no-print {
  height: 60px;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #1b0000;
}
.body-box {
  border-radius: 4px;
}
.receive {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/check-out/components/SelectPrinter.vue